/**
 * TypeScript requires us to declare any properties we add to the global 'window' object.
 * This tells the compiler that 'window.OAC' is a valid and expected property,
 * preventing a compile-time error.
 */
declare global {
    interface Window {
        OCA: any;
    }
}

// -------------------------------------------------------------------
// STEP 1: Change your exports to local imports.
// This brings the functions into this file's scope so we can work with them.
// -------------------------------------------------------------------

import { getTimeZone } from "./site/timezone";
import { FormHelper } from "./site/formhelper";
import { setupRecaptcha } from "./site/recaptcha";


// -------------------------------------------------------------------
// STEP 2: Keep any "side-effect" imports as they are.
// This line does not export anything; it just runs the code inside the
// 'facilitylink.ts' file. It should remain unchanged.
// -------------------------------------------------------------------

import "./site/facilitylink";


// -------------------------------------------------------------------
// STEP 3: Manually expose your code to the global scope.
// This explicitly creates the global OAC.site_js object and attaches your code to it.
// -------------------------------------------------------------------

// Ensure the global OAC object exists, creating it if it doesn't.
window.OCA = window.OCA || {};

// Assign your imported code to the 'site_js' property on the OAC object.
window.OCA.site_js = {
    getTimeZone: getTimeZone,
    FormHelper: FormHelper,
    setupRecaptcha: setupRecaptcha
};